import script from "./Ajuda.vue?vue&type=script&setup=true&lang=js"
export * from "./Ajuda.vue?vue&type=script&setup=true&lang=js"

import "./Ajuda.vue?vue&type=style&index=0&id=18fca9a4&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18fca9a4"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QExpansionItem,QCard,QCardSection});
